module.exports = __webpack_public_path__ + "img/mecatronic_diagram.f5422cf1.png";